import { SET_ASSITERS_PLAYERS } from "../constants";

const initialState = {
    assitersByTournament: [],
}


function assisterPlayer(state = initialState, action) {
switch (action.type) {
    case SET_ASSITERS_PLAYERS:
        return {...state, assitersByTournament: action.payload};

    default:
        return initialState;
}

}

export default assisterPlayer